import { ValueOf } from '../utilities/types';

const formConditionTypes = {
  EQUALITY: 'equality',
} as const;

export type FormConditionTypes = ValueOf<typeof formConditionTypes>;

export default formConditionTypes;
